'use client';

import { useState } from 'react';

interface FAQItem {
  question: string
  answer: string | React.ReactNode
  isOpen: boolean
}

export default function FAQSection() {
  const [faqItems, setFaqItems] = useState<FAQItem[]>([
    {
      question: "Como funciona a IA no WhatsApp? Ela realmente consegue qualificar leads sozinha?",
      answer: "Sim, e com precisão. A IA atende cada lead que entra no seu WhatsApp em menos de 60 segundos, 24/7. Ela faz as perguntas de qualificação que você definiu, identifica se o lead é qualificado ou não, e passa apenas os qualificados para seus vendedores. ",
      isOpen: true
    },
    {
      question: "O que é exatamente esse 'dashboard' que vocês mencionam?",
      answer: "É um painel de controle personalizado onde você visualiza todas as métricas importante para o seu negócio em tempo real. Você vê: quantos leads foram atendidos hoje, taxa de qualificação, quantos follow-ups foram enviados, qual horário tem mais conversões, principais objeções dos leads, tempo médio de resposta, e muito mais. Não é um dashboard genérico com métricas que não importam — construímos especificamente com os KPIs que fazem diferença para o SEU negócio. Você finalmente tem visibilidade total do seu comercial.",
      isOpen: false
    },
    {
      question: "A IA consegue fazer follow-up automaticamente? Como isso funciona?",
      answer: "Perfeitamente. A IA faz follow-up no timing ideal (que definimos juntos baseado no seu histórico de conversões), com mensagens personalizadas conforme o estágio do lead. Se o lead não responde, ela tenta novamente. Se o lead volta depois de semanas, ela retoma a conversa do ponto certo. E o melhor: o dashboard mostra quantos follow-ups foram feitos, taxa de reativação por tentativa, e quais leads 'mortos' voltaram à vida.",
      isOpen: false
    },
    {
      question: "Quanto custa implementar essa solução?",
      answer: "O investimento varia conforme a complexidade do seu processo, volume de leads e integrações necessárias. Por isso fazemos o Raio-x Operacional primeiro — analisamos sua operação e apresentamos uma proposta personalizada com valores transparentes. O que posso garantir: mesmo considerando todos os custos (implementação + acompanhamento mensal), ainda sai significativamente mais barato que manter SDRs humanos fazendo o mesmo trabalho. E a IA trabalha 24/7 sem férias, atestados ou variação de qualidade.",
      isOpen: false
    },
    {
      question: "Em quanto tempo vejo retorno do investimento (ROI)?",
      answer: "A maioria dos clientes atinge ROI positivo entre 60-90 dias depois que a IA estiver em produção. Durante a apresentação do Plano de Ação, mostramos uma projeção de ROI baseada nos SEUS números reais (volume de leads, taxa de conversão atual, custo de SDR, ticket médio). Não é promessa vazia — são dados concretos, mensuráveis, visíveis.",
      isOpen: false
    },
    {
      question: " Quanto tempo leva para ter a IA funcionando?",
      answer: <>Entre 2 a 4 meses, dependendo da complexidade do seu processo comercial. Sei que você já viu promessas de &apos;entrega em 1 mês, 3 semanas ou até mesmo em 2 semanas&apos;, mas essas implementações costumam falhar porque pulam a fase mais crítica: <strong className='text-off-white' >o treinamento profundo da IA</strong>. <br/><br/>Minha abordagem dedica 80% do tempo treinando a IA para seguir perfeitamente as regras do seu negócio e testando centenas de cenários ANTES dela falar com clientes reais. Outras agências implementam rápido e descobrem os erros em produção — com seus clientes pagando o preço. Você não quer seus clientes virando cobaias de teste. <br/><br/><strong>Você prefere: IA quebrada em 2 semanas ou IA funcionando perfeitamente em 3 meses?</strong></>,
      isOpen: false
    },
    {
      question: "A IA se integra com as ferramentas que já uso (CRM, calendário, etc)?",
      answer: "Sim. Durante o Diagnóstico, mapeamos todas as suas ferramentas atuais. Trabalhamos com as principais plataformas (RD Station, HubSpot, Pipedrive, Google Calendar, Calendly, etc) e construímos integrações customizadas quando necessário. Como sou Desenvolvedor Full Stack, posso integrar praticamente qualquer sistema via API. A IA não fica isolada — ela se conecta ao seu ecossistema existente criando um fluxo comercial unificado.",
      isOpen: false
    },
    {
      question: " Vocês usam APIs oficiais ou aquelas 'gambiarras' que podem me fazer perder o número do WhatsApp?",
      answer: "Apenas APIs oficiais do WhatsApp Business. Esse é um diferencial crítico (e um erro comum no mercado). Muitas soluções baratas usam APIs não-oficiais que violam os termos de uso e resultam em banimento permanente do seu número. Trabalhamos exclusivamente com infraestrutura oficial da Meta, garantindo segurança, estabilidade e conformidade total. Seu número está protegido.",
      isOpen: false
    },
    {
      question: "Já tentei implementar IA antes e foi um desastre. Por que dessa vez seria diferente?",
      answer: <>Porque provavelmente você trabalhou com quem vende IA, não com quem constrói IA do zero. Quando a IA inventa perguntas, pula etapas ou faz follow-up errado, é falha técnica de programação. Como Desenvolvedor Full Stack e Especialista em LLMs (GPT, Claude, Gemini), construo a lógica, testo cada cenário, uso apenas APIs oficiais e crio sistemas robustos. Além disso, a Metodologia D.P.E. garante que entendemos profundamente SEU processo antes de codar qualquer coisa.<br/><br/> <strong>Veja os depoimentos: até profissionais técnicos de IA confiam no meu trabalho.</strong></>,
      isOpen: false
    },
    {
      question: "Como funciona o acompanhamento mensal?",
      answer: "Fazemos reuniões periódicas de otimização baseadas nos dados do dashboard e na performance do agente em contato com os seus clientes, ajustamos scripts conforme necessário, e estou disponível para resolver dúvidas e implementar melhorias. Não sou um fornecedor pontual — sou um parceiro de negócio investindo no seu crescimento. A mesma atenção, paciência e profissionalismo que você vê nos depoimentos é o que você terá no seu projeto.",
      isOpen: false
    },
    {
      question: "E se meu processo comercial mudar futuramente?",
      answer: <>É por isso que fazemos o acompanhamento mensal. Caso seu processo comercial mude, você adicione mais ferramentas na sua operação ou deixe de usar outras, no acompanhamento mensal iremos entender a nova dinâmica do seu comercial e adaptar a interação da IA para que ela continue performando e aumentando seu faturamento. <br/><br/><strong>Pode ficar tranquilo, aqui você não ficará desamparado.</strong></>,
      isOpen: false
    },
    {
      question: "Posso testar antes de implementar com leads reais?",
      answer: "Sim. Após aprovar a proposta, fazemos testes internos completos antes do go-live. Você valida toda a operação da IA, revisa scripts, testa integrações e só ativamos com leads reais quando você estiver 100% confiante. O go-live é assistido — monitoramos em tempo real os primeiros dias para garantir performance ideal.",
      isOpen: false
    }
  ])

  const toggleFAQ = (index: number) => {
    setFaqItems(prev => prev.map((item, i) => ({
      ...item,
      isOpen: i === index ? !item.isOpen : false
    })))
  }

  return (
    <section id="faq" className="w-full bg-[#02020c] py-[26px] sm:py-[39px] lg:py-[52px]">
      <div className="w-full max-w-7xl mx-auto px-4">
        <div className="flex flex-col gap-[26px] sm:gap-[39px] lg:gap-[52px] justify-start items-center w-full">
          {/* Section Header */}
          <div className="flex flex-col gap-[5px] sm:gap-[7px] lg:gap-[10px] justify-start items-center w-full max-w-[524px]">
            <h2 
              className="text-[25px] sm:text-[37px] lg:text-[50px] font-normal leading-[30px] sm:leading-[44px] lg:leading-[59px] text-center bg-gradient-to-b from-[#f7faff] to-[#9eb5dc] bg-clip-text text-transparent"
              style={{ fontFamily: 'Raleway' }}
            >
              Perguntas Frequentes
            </h2>
            <p 
              className="text-[12px] sm:text-[18px] lg:text-[24px] font-normal leading-[12px] sm:leading-[18px] lg:leading-[24px] text-center text-[#b7c3d7] w-full"
              style={{ fontFamily: 'Raleway' }}
            >
              Talvez você tenha algumas dúvidas em como a IA chegou para revolucionar o seu negócio..
            </p>
          </div>

          {/* FAQ Items */}
          <div className="flex flex-col gap-[8px] sm:gap-[12px] lg:gap-[16px] w-full">
            {faqItems.map((item, index) => (
              <div key={index} className="w-full">
                {item.isOpen ? (
                  // Expanded FAQ Item
                  <div className="flex flex-col gap-[12px] sm:gap-[18px] lg:gap-[24px] justify-center items-center w-full bg-[#fffefe05] border border-[#fffefe0a] rounded-[16px] py-[15px] sm:py-[22px] lg:py-[30px] px-[15px] sm:px-[22px] lg:px-[30px]">
                    {/* Question Header */}
                    <button 
                      onClick={() => toggleFAQ(index)}
                      className="flex items-center justify-between w-full"
                    >
                      <span 
                        className="text-[9px] sm:text-[13px] lg:text-[18px] font-normal leading-[11px] sm:leading-[16px] lg:leading-[22px] text-left text-[#ffffff]"
                        style={{ fontFamily: 'Raleway' }}
                      >
                        {item.question}
                      </span>
                      <img
                        src="/images/img_svg.png"
                        alt="Expand Icon"
                        className="w-[11px] h-[12px] sm:w-[16px] sm:h-[18px] lg:w-[22px] lg:h-[24px]"
                      />
                    </button>
                    
                    {/* Answer */}
                    <div className="flex items-center justify-start w-full">
                      <p 
                        className="text-[9px] sm:text-[13px] lg:text-[18px] font-normal leading-[13px] sm:leading-[19px] lg:leading-[25px] text-left text-[#77797f] w-[86%]"
                        style={{ fontFamily: 'Raleway' }}
                      >
                        {item.answer}
                      </p>
                    </div>
                  </div>
                ) : (
                  // Collapsed FAQ Item
                  <button 
                    onClick={() => toggleFAQ(index)}
                    className="flex items-center justify-between w-full bg-[#fffefe05] border border-[#fffefe0a] rounded-[16px] py-[16px] sm:py-[24px] lg:py-[32px] px-[16px] sm:px-[24px] lg:px-[32px]"
                  >
                    <span 
                      className="text-[9px] sm:text-[13px] lg:text-[18px] font-normal leading-[11px] sm:leading-[16px] lg:leading-[22px] text-left text-[#ffffff] self-end"
                      style={{ fontFamily: 'Raleway' }}
                    >
                      {item.question}
                    </span>
                    <img
                      src="/images/img_arrow_down.svg"
                      alt="Collapse Icon"
                      className="w-[11px] h-[12px] sm:w-[16px] sm:h-[18px] lg:w-[22px] lg:h-[24px]"
                    />
                  </button>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
